import axios from 'axios'
import pageView from './pageView.js'

/*
 * Client-side logging.
 *
 * Was an Angular factory taking `$http` (step 28 of #614). The two that need a token use axios
 * rather than fetch, because app.js installs a request interceptor on the shared axios instance
 * that attaches the Cognito token - which is exactly what `$http`'s interceptor was doing for
 * these calls.
 *
 * `pageView` is the anonymous one and stays on fetch: it takes no token, and an authenticated
 * client needs a session, so the landing page could never be counted through one.
 */
const logService = {
  log: msg => axios.post('/api/log', { msg: msg }),

  pageView: pageView,
}

export default logService
